import React from 'react'
import { user } from 'ampersand-app'

import { experimentalFeatures } from '@/modules/base/util/constants'
import RagChatSection from '@/modules/document/components/document-drawer/rag-chat-section'
import {
  ReceiptFileReference,
  useReceiptDetailAssistantDocument,
} from '@/modules/expense-revenue/components/drawer/use-receipt-detail-assistant-document'

interface ReceiptDetailAssistantProps {
  receipt?: ReceiptFileReference | null
}

const ReceiptDetailAssistant = ({ receipt }: ReceiptDetailAssistantProps) => {
  const features = user?.experimentalFeatures ?? []
  // The outer gate preserves the quick drawer's flag-OFF DOM and network behavior. RagChatSection
  // repeats the enhancement gate for its other hosts, but waiting until there would already have
  // paid for a file-info request that cannot render anything.
  const enabled = features.includes(experimentalFeatures.useDocuAi)
    && features.includes(experimentalFeatures.docuAiEnhancements)
  const document = useReceiptDetailAssistantDocument(enabled, receipt)

  return enabled && document ? <RagChatSection document={document} /> : null
}

export default ReceiptDetailAssistant
